module.exports = __webpack_public_path__ + "static/media/firefox-logo.2c4b0a0d.svg";